var e4 = e4 || {},
    bionordika = bionordika || {};

bionordika.productDescriptionToggle = {
    init: function () {
        var jCollapseSection = jQuery( '.js-bionordika-section-collapse-content' ),
            jCollapseSectionBtnContainer = jQuery('.js-bionordika-section-collapse-toggle-btn-container');
        if ( jCollapseSection.height() <= jCollapseSection.find( '.row' ).prop( 'scrollHeight' ) ) {
            jCollapseSectionBtnContainer.addClass('is-possible');
            jCollapseSection.addClass('is-possible');
        }
        else {
            jCollapseSectionBtnContainer.removeClass('is-possible');
            jCollapseSection.removeClass('is-possible');
        }
    }
};

bionordika.linkLogic = {
    init: function () {
        var downloadLinksWithTargetBlank = jQuery('.js-e-content').find('a[href*="DWSDownload.aspx"][target="_blank"]');
        if (downloadLinksWithTargetBlank.length > 0){
            bionordika.linkLogic.removeDWSDownloadFromLink(downloadLinksWithTargetBlank);
        }
    },
    removeDWSDownloadFromLink: function (downloadLinksWithTargetBlank) {
        jQuery.each(downloadLinksWithTargetBlank, function (intIndex, domLink) {
            domLink.href = decodeURIComponent(domLink.href.split('File=')[1]).replace(/\+/g, '%20');
        });
    }
};

bionordika.cursorTextBox = {
    init: function () {
        if ( jQuery( window ).width() >= 768 ) {
            bionordika.cursorTextBox.bindEvents();
        }
    },
    bindEvents: function () {
        var jTextBox = bionordika.cursorTextBox.getTextBox();
        var jAsideNavLink = jQuery( '.e-nav-aside > .nav > .nav-item > .nav-link' );

        jQuery( '.js-e-header' ).on( 'mousemove', function ( event ) {
            if ( jQuery( '.js-e-header' ).hasClass( 'is-stuck is-hidden' ) ) {
                jTextBox.addClass( 'is-below' );
            }
            else {
                jTextBox.removeClass( 'is-below' );
            }

            bionordika.cursorTextBox.setPosition( bionordika.cursorTextBox.getCursorPositionByEvent( event ) );
        } );

        jAsideNavLink.on( 'mouseenter', function ( event ) {
            var navItemPageName = jQuery( event.target ).find( '.e-nav-pagename' ).html();
            jTextBox.html( navItemPageName );
            bionordika.cursorTextBox.show( jTextBox );
        } ).on( 'mouseleave', function ( event ) {
            bionordika.cursorTextBox.hide( jTextBox );
        } );
    },

    getCursorPositionByEvent: function ( event ) {
        var cursorPositionData = {};

        cursorPositionData.xAxis = event.pageX;
        cursorPositionData.yAxis = event.pageY;

        return cursorPositionData;
    },
    setPosition: function ( cursorData ) {
        var jTextBox = bionordika.cursorTextBox.getTextBox();
        jTextBox.css( 'top', cursorData.yAxis );
        jTextBox.css( 'left', cursorData.xAxis );
    },
    getTextBox: function () {
        return jQuery( '.js-bionordika-cursor-text-box' );
    },
    show: function ( domNode ) {
        domNode.addClass( 'is-visible' );
    },
    hide: function ( domNode ) {
        domNode.removeClass( 'is-visible' );
    }
};

bionordika.owlCarousel = {
    init: function () {
        if ( bionordika.owlCarousel.getCarousel().length > 0 ) {
            bionordika.owlCarousel.getCarousel().each( function () {
                bionordika.owlCarousel.build( this );
            } );

        }
    },
    build: function ( domSlider ) {
        e4.require.js( e4.settings.require.owlcarousel, function () {


            var jSlider = jQuery( domSlider ),
                intSliderItems = jSlider.data( 'slider-items' ),
                boolSliderNav = ( jSlider.data( 'slider-nav' ) === '' ) ? 'false' : jSlider.data( 'slider-nav' ),
                boolSliderNavSmall = ( jSlider.data( 'slider-nav-small' ) === '' ) ? 'false' : jSlider.data( 'slider-nav-small' ),
                boolSliderNavText = jSlider.data( 'slider-nav-text' ),
                boolSliderLoopSmall = ( jSlider.data( 'slider-loop-small' ) === '' ) ? 'false' : jSlider.data( 'slider-loop-small' ),
                intSliderMargin = ( jSlider.data( 'slider-margin' ) === '' ) ? 0 : jSlider.data( 'slider-margin' ),
                intSliderMarginSmall = 17,
                intSliderStagePaddingSmall = ( jSlider.data( 'slider-item-count' ) > 1 ) ? jSlider.data( 'slider-stage-padding' ) : 0,
                intSliderItemsBreakpointSmall = ( jSlider.data( 'slider-items-breakpoint-small' ) === '' ) ? 1 : jSlider.data( 'slider-items-breakpoint-small' ),
                intSliderItemsBreakpointMedium = ( jSlider.data( 'slider-items-breakpoint-medium' ) === '' ) ? 2 : jSlider.data( 'slider-items-breakpoint-medium' ),
                intSliderItemsBreakpointLarge = ( jSlider.data( 'slider-items-breakpoint-large' ) === '' ) ? intSliderItems : jSlider.data( 'slider-items-breakpoint-large' );

            jSlider.owlCarousel( {
                item: intSliderItems,
                margin: intSliderMargin,
                animateIn: true,
                rewind: true,
                nav: boolSliderNav,
                navText: boolSliderNavText,
                responsiveClass: true,
                responsive: {
                    0: {
                        items: intSliderItemsBreakpointSmall,
                        margin: intSliderMarginSmall,
                        stagePadding: intSliderStagePaddingSmall,
                        loop: boolSliderLoopSmall,
                        nav: boolSliderNavSmall,
                    },
                    576: {
                        items: intSliderItemsBreakpointMedium,
                        loop: false,
                    },
                    768: {
                        items: intSliderItemsBreakpointLarge,
                        loop: false,

                    }
                }
            } );
        } );
    },
    getCarousel: function () {
        return jQuery( '.js-bionordika-owl-carousel' );
    }
};

bionordika.megamenu = {
    init: function () {
        if ( jQuery( window ).width() > 768 ) {
            bionordika.megamenu.setActiveNavLevelOnLoad();
            bionordika.megamenu.bindEvents();
        }
    },
    bindEvents: function () {
        jQuery( '.js-e-nav-global .js-bionordika-nav-parent-level-3' ).on( 'click', function ( event ) {
            event.preventDefault();
            var jTarget = jQuery( event.target );
            bionordika.megamenu.toggleActiveNavLevel();
            jTarget.find( '.is-child' ).addClass( 'is-active' );
            jTarget.addClass( 'is-active' );
        } );

        jQuery( '.js-e-nav-global .js-bionordika-nav-parent-level-4' ).on( 'click', function ( event ) {
            event.stopPropagation();
        } );
    },
    toggleActiveNavLevel: function () {
        jQuery( '.js-e-nav-global .js-bionordika-nav-parent-level-3' ).each( function ( index, domElm ) {
            var jNavItem = jQuery( domElm );
            jNavItem.find( '.is-child' ).removeClass( 'is-active' );
            jNavItem.removeClass( 'is-active' );
        } );
    },
    setActiveNavLevelOnLoad: function () {
        var jNavParentLevel3 = jQuery( '.js-e-nav-global .js-bionordika-nav-parent-level-3' );
        jNavParentLevel3.each( function ( index, domElm ) {
            var jNavItem = jQuery( domElm );
            jNavItem.removeClass( 'is-active' );
            jNavItem.find( '.is-child' ).removeClass( 'is-active' );

            if ( jNavParentLevel3.find( '.is-inpath' ).length === 0 ) {
                if ( index === 0 ) {
                    jNavItem.addClass( 'is-active' );
                    jNavItem.find( '.is-child' ).addClass( 'is-active' );
                }
            }
            else if ( jNavItem.is( '.is-inpath' ) ) {
                jNavItem.addClass( 'is-active' );
                jNavItem.find( '.is-child' ).addClass( 'is-active' );
            }

        } );
    }
};

bionordika.items = {
    const: {
        jItemListContainers: null,
        indexPrevSelectedValues: [],
    },

    init: function () {
        if ( jQuery( '.js-bionordika-itemlist-with-facets' ).length > 0 ) {
            e4.require.js( e4.settings.require.handlebars, function () {
                bionordika.items.const.jItemListContainers = jQuery( '.js-bionordika-itemlist-with-facets' );
                bionordika.items.const.jItemListContainers.each( function ( intIndex, domElement ) {
                    jQuery( domElement ).find( '.js-bionordika-handlebars-template-container' ).each( function ( _intIndex, _domElement ) {
                        e4.handlebars.registerTemplates( jQuery( _domElement ).data( 'handlebarTemplateId' ) );
                    } );
                } );
                bionordika.items.bindEvents();
            } );
        }
    },
    bindEvents: function () {
        bionordika.items.const.jItemListContainers.on( 'change', '.js-bionordika-itemlist-filter-form', function ( event ) {
        } ).on( 'show.bs.dropdown', '.js-e-select-multiple', function ( event ) {
            const jDropdown = jQuery( event.currentTarget );
            bionordika.items.const.indexPrevSelectedValues[ jDropdown.data( 'key' ) ] = jDropdown.find( 'input:checked' ).serializeArray();
        } ).on( 'hidden.bs.dropdown', '.js-e-select-multiple', function ( event ) {
            const jDropdown = jQuery( event.currentTarget ),
                jInputDataArray = bionordika.items.const.indexPrevSelectedValues[ jDropdown.data( 'key' ) ];
            jDropdown.find( 'input[name="' + jDropdown.data( 'key' ) + '"]' ).prop( 'checked', false );
            jQuery.each( jInputDataArray, function ( intIndex, inputData ) {
                jDropdown.find( 'input[name="' + jDropdown.data( 'key' ) + '"][value="' + inputData.value + '"]' ).prop( 'checked', true );
            } );
        } ).on( 'click', '.js-e-select-multiple-apply-btn', function ( event ) {
            const jDropdown = jQuery( event.currentTarget ).closest( '.js-e-select-multiple' ),
                jContainer = jQuery( event.currentTarget ).closest( '.js-bionordika-itemlist-with-facets' ),
                jForm = jContainer.find( '.js-bionordika-itemlist-filter-form' );
            bionordika.items.const.indexPrevSelectedValues[ jDropdown.data( 'key' ) ] = jDropdown.find( 'input:checked' ).serializeArray();
            jDropdown.find( '.close' ).trigger( 'click' );
            bionordika.items.build( jForm );
        } ).on( 'click', '.js-e-itemlist-clear-selected-facet-option-btn', function ( event ) {
            const jSelectedOption = jQuery( event.currentTarget ),
                jInput = bionordika.items.const.jItemListContainers.find( 'input[name="' + jSelectedOption.data( 'facetParameterName' ) + '"][value="' + jSelectedOption.data( 'facetOptionValue' ) + '"]' );
            jInput.trigger( 'click' );
            jInput.closest( '.js-e-select-multiple-content' ).find( '.js-e-select-multiple-apply-btn' ).trigger( 'click' );

        } ).on( 'click', '.js-e-productlist-clear-all-selected-facet-options-btn', function ( event ) {
            var jContainer = jQuery( event.currentTarget ).closest( '.js-bionordika-itemlist-with-facets' ),
                jForm = jContainer.find( '.js-bionordika-itemlist-filter-form' );
            jContainer.find( '.js-e-itemlist-clear-selected-facet-option-btn' ).each( function ( intIndex, domElement ) {
                var jElement = jQuery( domElement );
                jContainer.find( 'input[name="' + jElement.data( 'facetParameterName' ) + '"][value="' + jElement.data( 'facetOptionValue' ) + '"]' ).prop( 'checked', false );
            } );
            bionordika.items.const.indexPrevSelectedValues = [];
            bionordika.items.build( jForm );
        } );
    },
    build: function ( jForm ) {
        var jContainer = jForm.closest( '.js-bionordika-itemlist-with-facets' );
        bionordika.items.getJson( jContainer, {
            url: jForm.data( 'feedUrl' ),
            data: jForm.serialize(),
            method: 'GET'
        }, function ( jsonData ) {
            jContainer.find( '.js-bionordika-itemlist-items' ).html( e4.handlebars.tmpl[ e4.handlebars.getTemplateName( jContainer.find( '.js-bionordika-itemlist-items' ).data( 'handlebarTemplateId' ) ) ]( jsonData ) );
            jContainer.find( '.js-bionordika-itemlist-selected-facets' ).html( e4.handlebars.tmpl[ e4.handlebars.getTemplateName( jContainer.find( '.js-bionordika-itemlist-selected-facets' ).data( 'handlebarTemplateId' ) ) ]( jsonData ) );
        } );
    },
    getJson: function ( jContainer, objAjaxSettings, fnCallback ) {
        var jqXHR = jQuery.ajax( jQuery.extend( {
            method: 'GET',
            dataType: 'json',
            enctype: 'multipart/form-data',
            processData: false,
            contentType: false,
            cache: false,
            beforeSend: function () {
                jContainer.find( '.js-e-loading-overlay' ).addClass( 'is-loading' );
            }
        }, objAjaxSettings ) );
        jqXHR.done( function ( data ) {
            if ( typeof fnCallback === 'function' ) {
                fnCallback( data );
            }
            setTimeout( function () {
                jContainer.find( '.js-e-loading-overlay' ).removeClass( 'is-loading' );
            }, 250 );
        } );
    }
};

bionordika.suppliers = {
    jSupplierList: null,
    init: function(){
        bionordika.suppliers.jSupplierList = jQuery('.js-bionordika-supplierlist');
        if ( bionordika.suppliers.jSupplierList.length > 0 ){
            bionordika.suppliers.bindEvents();
        }
    },
    bindEvents: function(){
        bionordika.suppliers.jSupplierList
        .on('click', '.js-bionordika-supplierlist-clear-selected-facet-option-btn', function(event){
            bionordika.suppliers.resetField(jQuery(event.currentTarget).data());
            bionordika.suppliers.jSupplierList.find('.js-bionordika-supplierlist-form').submit();
        })
        .on('click', '.js-bionordika-supplierlist-clear-all-selected-facet-options-btn', function(event){
            jQuery.each(bionordika.suppliers.jSupplierList.find('.js-bionordika-supplierlist-clear-selected-facet-option-btn'), function(intIndex, domElement){
                bionordika.suppliers.resetField(jQuery(domElement).data());
            });
            bionordika.suppliers.jSupplierList.find('.js-bionordika-supplierlist-form').submit();
        });
    },
    resetField: function(jTargetData){
        if ( jTargetData.facetParameterName === 'Supplier' ){
            bionordika.suppliers.jSupplierList.find('input[name="'+jTargetData.facetParameterName+'"]').val('');
        } else {
            bionordika.suppliers.jSupplierList.find('input[name="'+jTargetData.facetParameterName+'"][value="'+jTargetData.facetOptionValue+'"]').prop('checked', false);
        }
    }
};

bionordika.ecom = {
    init: function () {
        bionordika.ecom.bindEvents();
    },
    bindEvents: function () {
        jQuery( '.js-bionordika-request-price-modal' ).on( 'show.bs.modal', function ( event ) {
            bionordika.ecom.requestPrice.buildModalContent( event );
            var jCartModal = jQuery( '.js-bionordika-add-to-cart-modal' );
            if ( jCartModal.length === 1 && jCartModal.data( 'bs.modal' ) !== undefined && jCartModal.data( 'bs.modal' )._isShown === true ) {
                jCartModal.modal( 'hide' );
            }
        } ).on( 'hidden.bs.modal', function ( event ) {
            bionordika.ecom.requestPrice.clearModalContent( event );
        } );
        jQuery( '.js-bionordika-request-price-modal, .js-bionordika-add-to-cart-modal' ).on( 'show.bs.modal', function ( event ) {
            if ( e4.hash.get( 'search' ) !== undefined ) {
                jQuery( event.target ).data( 'search-query-to-restore', e4.hash.get( 'search' ) );
                e4.hash.remove( 'search' );
            }
        } ).on( 'hidden.bs.modal', function ( event ) {
            var strSearchQueryToRestore = jQuery( event.target ).data( 'search-query-to-restore' );
            if ( strSearchQueryToRestore !== undefined && strSearchQueryToRestore !== null ) {
                e4.hash.set( 'search', strSearchQueryToRestore );
                jQuery( event.target ).data( 'search-query-to-restore', null );
            }
        });
        jQuery('.js-e-cart-form').on('change', '.js-e-orderline-override-price-input', e4.util.debounce(function (event) {
            bionordika.ecom.updateOrderline.overridePrice(event.target);
        }, e4.settings.debounceDelay.input * 4));
        jQuery('.js-e-cart-form').on('click', '.js-show-price-change-field', function (event) {
            bionordika.ecom.updateOrderline.showOverridePriceField(event.target);
        });
    },
    requestPrice: {
        buildModalContent: function ( event ) {
            var jProduct = jQuery( event.relatedTarget ).closest( '.js-e-productlist-item, .js-e-product' ),
                strProductId = jProduct.data( 'productId' ),
                strProductName = jProduct.data( 'productName' );
            jQuery.ajax( {
                url: 'system/global-content/request-price-form',
                dataType: 'html'
            } ).done( function ( strHtml ) {
                var jContentHtml = jQuery( strHtml ).find( '.js-e-content' ).find( '.container-fluid' ).first(),
                    jModal = jQuery( event.target );
                jContentHtml.find( '.js-bionordika-request-price-form-productId' ).val( strProductId );
                jContentHtml.find( '.js-bionordika-request-price-form-productName' ).val( strProductName );
                jModal.find( '.js-bionordika-request-price-content' ).html( jContentHtml.html() );
                jModal.modal( 'handleUpdate' );
                jModal.find( 'form' ).validate( {
                    submitHandler: bionordika.ecom.requestPrice.formSubmitHandler
                } );
            } );
        },
        clearModalContent: function ( event ) {
            jQuery( event.target ).find( '.js-bionordika-request-price-content' ).html( '' );
        },
        formSubmitHandler: function ( domForm ) {
            var jForm = jQuery( domForm ),
                fnDwFormSpamScript = e4.data.get( 'forms.dwSpamScripts.' + domForm.id );
            if ( jQuery.isFunction( fnDwFormSpamScript ) === true ) {
                fnDwFormSpamScript.call( window, domForm );
            }
            if ( domForm.elements[ e4.settings.forms.submitPageFieldName ] !== undefined ) {
                domForm.elements[ e4.settings.forms.submitPageFieldName ].value = location.href;
            }
            e4.util.disableAllSubmitButtonsInForm( domForm );
            jQuery.ajax( {
                url: jForm.attr( 'action' ),
                dataType: 'html',
                data: jForm.serialize(),
                method: 'POST'
            } ).done( function ( strHtml ) {
                var jContentHtml = jQuery( strHtml ).find( '.js-e-content' ).find( '.container-fluid' ).first(),
                    jModal = jQuery( domForm ).closest( '.modal' );
                jModal.find( '.js-bionordika-request-price-content' ).html( jContentHtml.html() ).find( '.btn' ).on( 'click', function ( event ) {
                    event.preventDefault();
                    jModal.modal( 'hide' );
                } );
                jModal.modal( 'handleUpdate' );
            } );
        },
    },
    updateOrderline: {
        overridePrice: function (domForm)  {

            var jOrderline = jQuery(domForm).closest('.js-e-orderline');
            var jInputOverridePrice = jOrderline.find('.js-e-orderline-override-price-input');
            var newPrice = jInputOverridePrice.val();
            var originalPrice = jInputOverridePrice.attr('data-unit-price');

            if (newPrice === "" && originalPrice !== "") {
                newPrice = originalPrice;
            }
            else if (newPrice === "0") {
                newPrice = "0,0001";
            }

            var objData = {};
            objData['CartCmd'] = 'updateorderlines';
            objData['Redirect'] = 'false';
            objData['OrderContext'] = jQuery(domForm).find('.js-e-cart-form-ordercontext').val();
            objData['UnitPriceOrderLine' + jOrderline.attr('id')] = newPrice;

            e4.cart.ajax({
                data: objData
            }, function (jsonData) {
                e4.cart.updateContent(jsonData);
                e4.cart.orderline.setFocus(jOrderline.attr('id'));
            });
        },
        showOverridePriceField: function (domForm) {
            var jOrderline = jQuery(domForm).closest('.js-e-orderline');
            var jInputOverridePrice = jOrderline.find('.js-e-orderline-override-price-input');
            var jButtonShowChangePrice = jOrderline.find('.js-show-price-change-field');
            jButtonShowChangePrice.addClass('d-none');
            jInputOverridePrice.removeClass('d-none');
        }
    }
};
bionordika.extranet = {
    orders: {
        init: function () {
            bionordika.extranet.orders.datepicker.init();
        },
        datepicker: {
            init: function () {
                e4.require.js( e4.settings.require.datepicker, function () {
                    e4.require.js( e4.settings.require.datepickerLanguage, function () {
                        bionordika.extranet.orders.datepicker.bindEvents();
                    } );
                } );
            },
            bindEvents: function () {
                jQuery( '.js-bionordika-datepicker' ).datepicker( {} ).on( 'changeDate', function ( dateEvent ) {
                    bionordika.extranet.orders.datepicker.updateDateInput( dateEvent );
                } );
            },
            updateDateInput: function ( objEvent ) {
                var jTarget = jQuery( objEvent.target ),
                    jDatePickerFormGroup = jTarget.closest( '.js-bionordika-datepicker-form-group' ),
                    strDateFormat = jTarget.data( 'date-format' ).toLowerCase(),
                    strDateFormatted = objEvent.format( strDateFormat );
                jDatePickerFormGroup.find( '.js-bionordika-datepicker-input' ).val( strDateFormatted );

                if ( jDatePickerFormGroup.is( '.js-bionordika-datepicker-form-group-with-split-values' ) === true ) {
                    var intSelectedDay = objEvent.date.getDate(),
                        intSelectedMonth = objEvent.date.getMonth() + 1,
                        intSelectedYear = objEvent.date.getFullYear();
                    jDatePickerFormGroup.find( '.js-bionordika-datepicker-split-value-day-input' ).val( intSelectedDay );
                    jDatePickerFormGroup.find( '.js-bionordika-datepicker-split-value-month-input' ).val( intSelectedMonth );
                    jDatePickerFormGroup.find( '.js-bionordika-datepicker-split-value-year-input' ).val( intSelectedYear );
                }
            }
        }
    }
};
